import React from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { IconButton } from 'components/components/atoms';
import { Container, Section } from 'components/shared';
import styled from 'styled-components';

const StyledIconButton = styled(IconButton)`
  & svg {
    width: 0.75rem;
    width: 0.75rem;
  }
`;
const StyledSection = styled(Section)`
  padding-bottom: 0.625rem !important;
`;

const BackButtonBar = ({ fields }) => {
  const parentDisplayName = getFieldValue(fields, 'parentDisplayName');
  const parentURL = getFieldValue(fields, 'parentURL');

  if (!parentDisplayName && !parentURL) {
    return null;
  }

  return (
    <StyledSection>
      <Container>
        <a
          className='flex items-center cursor-pointer'
          href={parentURL}
          aria-label={'Back'}
        >
          <StyledIconButton
            icon='arrow-left'
            idIcon={'BackButton'}
            circled
            color='aqua'
            small
            hoverState
            buttonLabel={'Back'}
            title={'Back icon'}
          />
          <span className='ml-5 mt-1 text-mattamy-blue uppercase font-trade-gothic-20'>
            {parentDisplayName}
          </span>
        </a>
      </Container>
    </StyledSection>
  );
};

export default BackButtonBar;
